import { Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent } from 'react'

import { useToggleState } from '../../utils/useToggleState'
import { BuybackFormFinancingFragment } from '../BuybackFormFinancingFragment/BuybackFormFinancingFragment'
import { BuybackFormPayoutBreakdown } from '../BuybackFormPayoutBreakdown/BuybackFormPayoutBreakdown'
import { BuybackFormSummaryFragmentBuyback } from '../BuybackFormSummaryFragmentBuyback/BuybackFormSummaryFragmentBuyback'
import { BuybackFormSummaryFragmentOffer } from '../BuybackFormSummaryFragmentOffer/BuybackFormSummaryFragmentOffer'
import { BuybackFormSummaryFragmentPayout } from '../BuybackFormSummaryFragmentPayout/BuybackFormSummaryFragmentPayout'
import { BuybackFormSummaryFragmentRentDuration } from '../BuybackFormSummaryFragmentRentDuration/BuybackFormSummaryFragmentRentDuration'
import { BuybackFormSummaryFragmentRentTotal } from '../BuybackFormSummaryFragmentRentTotal/BuybackFormSummaryFragmentRentTotal'
import { BuybackFormSummaryFragmentStatus } from '../BuybackFormSummaryFragmentStatus/BuybackFormSummaryFragmentStatus'
import { Fade } from '../Fade/Fade'

const gutter: Gutter | [Gutter, Gutter] = [16, 24]

export const BuybackFormSummaryFragment: FunctionComponent = () => {
  const [showFinancingDetails, toggleShowFinancingDetails] = useToggleState()
  const [showPayoutBreakdown, toggleShowPayoutBreakdown] = useToggleState()

  return (
    <>
      <Row gutter={gutter} className="mt-4 mb-12">
        <BuybackFormSummaryFragmentOffer />
        <BuybackFormSummaryFragmentBuyback />
        <BuybackFormSummaryFragmentRentDuration />
        <BuybackFormSummaryFragmentRentTotal />
        <BuybackFormSummaryFragmentPayout onClick={toggleShowPayoutBreakdown} />
        <BuybackFormSummaryFragmentStatus
          onClick={toggleShowFinancingDetails}
        />
      </Row>

      <Fade show={showFinancingDetails} unmount>
        <BuybackFormFinancingFragment toggleShow={toggleShowFinancingDetails} />
      </Fade>

      <Fade show={showPayoutBreakdown} unmount>
        <BuybackFormPayoutBreakdown toggleShow={toggleShowPayoutBreakdown} />
      </Fade>
    </>
  )
}
